/**
* directives.macros Module
*
* Description
*/
var app = angular.module('directives.macrosAttr', []);

	require('./macrosAttr.directive.js');
    require('./style.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/macrosAttr/index.js
 ** module id = 176
 ** module chunks = 1
 **/